import { Dispatch, SetStateAction } from "react";
import {
    Modal,
    Button,
    TextField,
    MenuItem,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function SelectAttribute({
    open,
    onClose,
    setOpen,
}: ModalProps) {

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
            <div className="modal-dialog">
                <div className="modal-body">
                    {/* HEADER */}
                    <div className="modal_title">
                        <h2>Select Attribute</h2>
                        <IconButton
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon sx={{ fontSize: '18px' }} />
                        </IconButton>
                    </div>

                    {/* FORM */}
                    <div className="form">
                        <div className="control_group" style={{ marginBottom: '30px' }}>
                            <label htmlFor="select-attribute">
                                Select Attribute
                            </label>
                            <TextField
                                select
                                fullWidth
                                defaultValue=""
                                variant="outlined"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': { borderColor: '#e2e8f0' },
                                        '&:hover fieldset': { borderColor: '#cbd5e1' },
                                        '&.Mui-focused fieldset': { borderColor: '#00A170' },
                                    }
                                }}
                                SelectProps={{
                                    displayEmpty: true,
                                    renderValue: (value: any) => value === "" ? "Select Attribute" : value
                                }}
                                inputProps={{ id: "select-attribute" }}
                            >
                                <MenuItem value="" disabled>Select Attribute</MenuItem>
                                <MenuItem value="Color">Color</MenuItem>
                                <MenuItem value="Size">Size</MenuItem>
                                <MenuItem value="Material">Material</MenuItem>
                                <MenuItem value="Brand">Brand</MenuItem>
                            </TextField>
                        </div>

                        {/* FOOTER */}
                        <div className="footer_btn_flex" style={{ display: 'flex', justifyContent: 'flex-end', gap: '15px' }}>
                            <Button
                                className="btn btn_grey"
                                variant="outlined"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Select
                            </Button>
                        </div>
                    </div>
                </div >
            </div >
        </Modal >
    );
}
